// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const articlesTeaserCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 2000,
  hasPagination: false,
  hasButtons: true,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: false,
  perPage: {
    mobile: 1,
    desktop: 3
  }
}

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */

export enum ArticlesTeaserVersion {
  Default = 'default',
  Stacked = 'stacked'
}
/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export const articlesTeaserVersionRegistry: Record<string, AsyncComponent> = {
  [ArticlesTeaserVersion.Default]: () => import(
    /* webpackChunkName: "modules/ArticlesTeaserDefault" */
    './versions/Default.vue'
  ),
  [ArticlesTeaserVersion.Stacked]: () => import(
    /* webpackChunkName: "modules/ArticlesTeaserCarousel" */
    './versions/Stacked.vue'
  )
}
